import { useContext, useState } from 'react';
import PdfViewerContext from './PdfViewerContext';
import { useMsal } from "@azure/msal-react";
import { useSelector } from 'react-redux';
import { getCurrentUser } from '../../constants/constants';

export const usePdfViewerInstance = () => {
   const { instance, annotManager } = useContext(PdfViewerContext);
   const { emails } = useMsal().instance.getActiveAccount()?.idTokenClaims;
   const activeUserEmailId = (Array.isArray(emails) ? emails[0] : emails).toLowerCase() || '';

   const [annotPosition, setAnnotPosition] = useState(0);
   const envelope = useSelector((state) => state.envelope?.entity?.recipients);

   const nextAnnotationField = () => {
      let annots = annotManager.getAnnotationsList();

      annots = annots.filter(a => getCurrentUser(envelope, activeUserEmailId, a) && a.Subject === "Widget");

      if (annots[annotPosition]) {
         annotManager.jumpToAnnotation(annots[annotPosition]);
         if (annots[annotPosition + 1]) {
            setAnnotPosition(annotPosition + 1);
         }
      }
   }

   const prevAnnotationField = () => {
      let annots = annotManager.getAnnotationsList();
      annots = annots.filter(a => getCurrentUser(envelope, activeUserEmailId, a) && a.Subject === "Widget");

      if (annots[annotPosition]) {
         annotManager.jumpToAnnotation(annots[annotPosition]);
         if (annots[annotPosition - 1]) {
            setAnnotPosition(annotPosition - 1);
         }
      }
   }

   const downloadPdf = (includeAnnotations = true, flatten = false) => {
      instance.UI.downloadPdf({
         includeAnnotations: includeAnnotations,
         flatten: flatten,
      });
   }

   const getPdfBlob = async () => {
      const { docViewer, annotManager } = instance;
      const doc = docViewer.getDocument();
      const xfdfString = await annotManager.exportAnnotations({ widgets: true, fields: true });
      const data = await doc.getFileData({ xfdfString });
      const arr = new Uint8Array(data);
      const blob = new Blob([arr], { type: 'application/pdf' });

      return blob;
   }

   const getAllFields = () => {
      const fieldManager = instance.Core.annotationManager.getFieldManager();

      const annots = instance.Core.annotationManager.getAnnotationsList();
      annots.forEach(annot => {
         const field = fieldManager.getField(annot.fieldName);
         console.log(field?.name, field?.value);
      });
   }

   return { instance, annotManager, nextAnnotationField, prevAnnotationField, downloadPdf, getPdfBlob, getAllFields };
};
